import { styled } from '@mui/material/styles'
import TableRow from '@mui/material/TableRow'

interface StyledTableRowProps {
	indicator?: 'Likely unused' | 'Possibly unused' | 'default';
}

export const StyledTableRow = styled(TableRow, {
	shouldForwardProp: (prop) => prop !== 'indicator' // prevent prop from reaching the DOM
})<StyledTableRowProps>(({ theme, indicator }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover
	},
	...(indicator === 'Likely unused' && {
		'&& td:first-of-type': {
			borderLeft: '3px solid #E62A33'
		}
	}),
	...(indicator === 'Possibly unused' && {
		'&& td:first-of-type': {
			borderLeft: '3px solid #FE9A00'
		}
	})
}))